import Wizard from './Wizard';
import './Wizard.scss';

export default Wizard;
